// generated by srcset-codegen
import src from "./app-download-qr.png";

const width = 2257;
const height = 2257;
export default { src, width, height };
